import { createContext } from "react";

const CompanyContext = createContext({});
const User = createContext({
  user : {},
  setUser : () => {}

});

export { CompanyContext, User };